import { render } from "./TemperatureModal.vue?vue&type=template&id=3cac95b0&ts=true"
import script from "./TemperatureModal.vue?vue&type=script&lang=ts"
export * from "./TemperatureModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__